import React from "react";

import { Button } from "./Button";

export const PauseButton = ({
  isPaused,
  onClick,
}: {
  isPaused: boolean;
  onClick: VoidFunction;
}) => (
  <Button onClick={onClick}>
    {isPaused ? (
      <svg fill="white" className="h-5 w-5" viewBox="0 0 20 20">
        <path d="M4 4l12 6-12 6z" />
      </svg>
    ) : (
      <svg fill="white" className="h-5 w-5" viewBox="0 0 20 20">
        <path d="M5 4h3v12H5V4zm7 0h3v12h-3V4z" />
      </svg>
    )}
  </Button>
);
